/*
 * fs-pdp-ugc.js — the three clips beside the buy button.
 *
 * They carry no `autoplay` and `preload="none"`, for the same reason the
 * community wall does: video that loads before it is on screen competes with
 * the product photography for the connection, and the photography is what the
 * shopper came for. These start when the row is visible and stop when it is
 * not.
 *
 * Without this file the row is three empty boxes, so it also removes itself —
 * an empty row beside the price is worse than no row.
 */
(function () {
  'use strict';

  var row = document.querySelector('[data-fs-pdp-ugc]');
  if (!row) return;

  var videos = Array.prototype.slice.call(row.querySelectorAll('[data-fs-pdp-ugc-video]'));
  if (!videos.length) return;

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    /* Nothing will move, so nothing will load, so the row would be blank. */
    row.remove();
    return;
  }
  if (!('IntersectionObserver' in window)) { row.remove(); return; }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) {
        if (!v.dataset.loaded) { v.src = v.getAttribute('data-src'); v.dataset.loaded = '1'; }
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) {
        v.pause();
      }
    });
  }, { rootMargin: '150px 0px', threshold: 0.2 });

  videos.forEach(function (v) { io.observe(v); });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) videos.forEach(function (v) { if (!v.paused) v.pause(); });
  });

  /* ── the clip, large, in a dialog ──
   * Clicking a clip used to navigate to the community page, which took the
   * shopper off the product to watch something already on their screen.
   *
   * The <video> is BUILT ON OPEN AND DESTROYED ON CLOSE. Leaving one parked in
   * a closed dialog keeps it buffering and holds the file in memory for a
   * shopper who watched it once.
   */
  var pop = document.querySelector('[data-fs-ugcpop]');
  var stage = pop && pop.querySelector('[data-fs-ugcstage]');
  if (!pop || !stage || typeof pop.showModal !== 'function') return;

  function shut() {
    /* Pause before emptying: a detached, still-playing element goes on
     * downloading in some browsers. */
    var v = stage.querySelector('video');
    if (v) { v.pause(); v.removeAttribute('src'); v.load(); }
    stage.textContent = '';
    if (pop.open) pop.close();
    /* The row behind was paused while the dialog covered it. */
    videos.forEach(function (el) {
      if (el.dataset.loaded) { var p = el.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-fs-ugc-open]');
    if (open && row.contains(open)) {
      e.preventDefault();
      videos.forEach(function (el) { if (!el.paused) el.pause(); });
      stage.textContent = '';
      var v = document.createElement('video');
      v.src = open.getAttribute('data-src');
      v.controls = true; v.loop = true; v.playsInline = true; v.autoplay = true;
      stage.appendChild(v);
      pop.showModal();
      /* Sound is what the shopper opened it for, and the click is the gesture
       * that permits it. If the browser refuses anyway, fall back to muted
       * rather than showing a still frame. */
      var p = v.play();
      if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); });
      return;
    }
    if (e.target.closest('[data-fs-ugcclose]')) { shut(); return; }
    if (e.target === pop) shut();
  });

  /* Escape fires close on the element itself, which bypasses shut(). */
  pop.addEventListener('close', function () {
    if (stage.firstChild) shut();
  });
})();
